module.exports = __webpack_public_path__ + "static/media/plan_linkage_view.d1bd549d.png";